import { Rate } from 'antd'
import React, { useEffect } from 'react'
import axios from 'axios'
import './GetReviews.css'
import spark from './spark.png'
import { ReviewObj } from '../../../Routes/Reviews'
import { useDispatch } from 'react-redux'
import { setIsLoadingTrue, setIsLoadingFalse } from '../../../redux/slices/LoadingSlice'


interface GetReviewsProps {
    setReviews: ([]) => void
    reviews: ReviewObj[]
}

const GetReviews = (props:GetReviewsProps) => {
    const dispatch = useDispatch()

const getReviews = () => {
    dispatch(setIsLoadingTrue())
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/getReviews`)
    .then(res => {
        console.log("Get Reviews Obj:", res)
        dispatch(setIsLoadingFalse())
        props.setReviews([...res.data])
    })
    .catch(err => {
        console.log("Error getReviews:", err)
    })
}
useEffect(() => {
    getReviews()
}, [])

return (
    <div>

<h1 className="text-color-white">Here's what others have to say:</h1>
    <div className="get-reviews-container">

        {props.reviews.map(item => {
            return (
        <div className="get-reviews">
        <div className="spark-container">
        <img className="spark" src={spark} />
        <img className="spark" src={spark} />
        </div>
        <div className="review-data">
        <Rate value={Number(item.rating)}/>
        <p>"{item.message}"</p>
        <span>-{item.name}</span> 
        </div>            
        <div className="spark-container">
        <img className="spark" src={spark} />
        <img className="spark" src={spark} />
        </div>
        </div>
        )
    })}
        </div>
    </div>
)
}

export default GetReviews

